import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import config from "./config";
import Menu from "./Menu";
import "./App.css";

const TriviaFeed = lazy(() => import("./TriviaFeed"));
const FeedToggle = lazy(() => import("./FeedToggle"));
const UserProfileFeed = lazy(() => import("./UserProfileFeed"));
const AddPost = lazy(() => import("./AddPost"));
const Account = lazy(() => import("./Account"));
const AdminGrid = lazy(() => import("./AdminGrid"));
const CategoryOrProfile = lazy(() => import("./CategoryOrProfile"));

const App = () => {
  useEffect(() => {
    const preference = localStorage.getItem("themePreference") || "system";
    const root = document.documentElement;
    if (preference === "system") {
      root.removeAttribute("data-theme");
    } else {
      root.setAttribute("data-theme", preference);
    }
  }, []);
  // Function to handle toggling feeds (you might want to save this to local storage as needed)
  const handleToggleFeeds = (updatedFeeds) => {
    console.log("Updated feeds:", updatedFeeds);
    // Optionally save it to localStorage or update global state
    localStorage.setItem("enabledFeeds", JSON.stringify(updatedFeeds));
  };

  return (
    <Router>
      <div className="app">
        <Suspense fallback={<div className="app__loading">Loading...</div>}>
          <Routes>
            <Route path="/" element={<TriviaFeed />} />
            <Route
              path="/accounts"
              element={
                <FeedToggle config={config} onToggle={handleToggleFeeds} />
              }
            />
            <Route path="/add-post" element={<AddPost />} />
            <Route path="/account" element={<Account />} />
            <Route path="/admin-grid" element={<AdminGrid />} />
            <Route path="/user/:username" element={<UserProfileFeed />} />
            <Route path="/:slug" element={<CategoryOrProfile />} />
          </Routes>
        </Suspense>
        <Menu />
        <div className="orientation-lock">Please rotate back to portrait.</div>
      </div>
    </Router>
  );
};

export default App;
